'use client';

import React, { useState } from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';

const timeframeOptions = [
  { value: 'NEVER', label: 'No Auto Refresh' },
  { value: 'MONTHLY', label: 'Commercial (monthly)' },
];

const StrategyTimeFrame = ({
  selectedTimeframe,
  onSelect,
}: {
  selectedTimeframe: 'NEVER' | 'MONTHLY';
  onSelect: (timeframe: string) => void;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectedOption =
    timeframeOptions.find((opt) => opt.value === selectedTimeframe) ||
    timeframeOptions[0];

  return (
    <div className="flex flex-col gap-1 relative">
      <label className="text-primary text-sm font-semibold leading-tight">
        Refresh Rate{' '}
        <span className="text-xs font-normal text-slate-600">
          (refresh rate)
        </span>
      </label>
      <div className="bg-white rounded-full border border-slate-200 relative">
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className="w-full px-4 py-3 text-left focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-sky-500 rounded-lg flex items-center justify-between"
        >
          <span className="text-xs text-slate-700 font-medium">
            {selectedOption.label}
          </span>
          <Icon
            icon={faCaretDown}
            className={`w-4 h-4 text-slate-500 transition-all duration-300 ${
              isOpen ? '-rotate-90' : 'rotate-0'
            }`}
          />
        </button>

        {isOpen && (
          <>
            <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-slate-200 rounded-lg shadow-lg z-50">
              {timeframeOptions.map((option) => (
                <button
                  key={option.value}
                  type="button"
                  onClick={() => {
                    onSelect(option.value);
                    setIsOpen(false);
                  }}
                  className={`w-full px-4 py-3 text-left text-xs font-medium hover:bg-slate-50 transition-colors ${
                    selectedTimeframe === option.value
                      ? 'bg-sky-50 text-sky-600'
                      : 'text-slate-700'
                  } ${option === timeframeOptions[0] ? 'rounded-t-lg' : ''} ${
                    option === timeframeOptions[timeframeOptions.length - 1]
                      ? 'rounded-b-lg'
                      : ''
                  }`}
                >
                  {option.label}
                </button>
              ))}
            </div>
            <div
              className="fixed inset-0 z-40"
              onClick={() => setIsOpen(false)}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default StrategyTimeFrame;
